import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import color from "../assets/data/color";
import size from "../assets/data/size";
import Products from "../components/Products";
import ShopFilters from "../components/Shop/ShopFilters";
import { fetchProducts } from "../apiCalls/product";
import { fetchCategories } from "../apiCalls/category";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

const ProductList = () => {
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.products.products);
  const categoryList = useSelector((state) => state.categories.categories);

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedSize, setSelectedSize] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);

  const [products, setProducts] = useState(productList);
  const [sorting, setSort] = useState("default");

  useEffect(() => {
    fetchProducts(dispatch);
    fetchCategories(dispatch);
  }, [dispatch]);

  // handle category checkbox change
  const handleCategoryChange = (category) => {
    console.log(category, "cat checked");
    const updatedCategories = [...selectedCategory];
    if (updatedCategories.includes(category)) {
      updatedCategories.splice(updatedCategories.indexOf(category), 1);
    } else {
      updatedCategories.push(category);
    }
    setSelectedCategory(updatedCategories);
  };

  // Handle size checkbox change
  const handleSizeChange = (size) => {
    const updatedSizes = [...selectedSize];
    if (updatedSizes.includes(size)) {
      updatedSizes.splice(updatedSizes.indexOf(size), 1);
    } else {
      updatedSizes.push(size);
    }
    setSelectedSize(updatedSizes);
  };

  // Handle color checkbox change
  const handleColorChange = (color) => {
    const updatedColors = [...selectedColor];
    if (updatedColors.includes(color)) {
      updatedColors.splice(updatedColors.indexOf(color), 1);
    } else {
      updatedColors.push(color);
    }
    setSelectedColor(updatedColors);
  };

  const sortProducts = (e) => {
    let newsortData;
    setSort(e.target.value);
    console.log(sorting);
    if (e.target.value === "a-z") {
      newsortData = products.slice().sort((a, b) => {
        return a.title.localeCompare(b.title);
      });
      setProducts(newsortData);
    }
    if (e.target.value === "z-a") {
      newsortData = products.slice().sort((a, b) => {
        return b.title.localeCompare(a.title);
      });
      setProducts(newsortData);
    }
    if (e.target.value === "low") {
      newsortData = products.slice().sort((a, b) => {
        return a.price - b.price;
      });
      setProducts(newsortData);
    }
    if (e.target.value === "high") {
      newsortData = products.slice().sort((a, b) => {
        return b.price - a.price;
      });
      setProducts(newsortData);
    }
  };

  useEffect(() => {
    // setProducts();
  }, [sorting]);

  const filteredProducts = products.filter((product) => {
    if (
      (selectedCategory.length === 0 ||
        selectedCategory.some((category) =>
          product.categories.map((c) => c._id).includes(category)
        )) &&
      (selectedSize.length === 0 ||
        selectedSize.some((size) => product.size.includes(size))) &&
      (selectedColor.length === 0 ||
        selectedColor.some((color) => product.color.includes(color)))
    ) {
      return true;
    }
    return false;
  });

  return (
    <>
      <Breadcrumb activeName={"Shop"} middleName={""} middleUrl={""} />
      <section className="product-list">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="product-list-data">
                <div className="product-filters">
                  <div className="filter-container">
                    <div className="filter">
                      <select onChange={sortProducts} value={sorting}>
                        <option value="default">Default</option>
                        <option value="low">Price (Low to High)</option>
                        <option value="high">Price (High to Low)</option>
                        <option value="a-z">Alphabet A-Z</option>
                        <option value="z-a">Alphabet Z-A</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="product-listing">
                  <ShopFilters
                    categoryList={categoryList}
                    color={color}
                    size={size}
                    handleCategoryChange={handleCategoryChange}
                    handleSizeChange={handleSizeChange}
                    handleColorChange={handleColorChange}
                    selectedCategory={selectedCategory}
                    selectedSize={selectedSize}
                    selectedColor={selectedColor}
                  />
                  <Products products={filteredProducts} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductList;
